window.addEventListener('DOMContentLoaded',()=>{
  var is_preorder = $('#preorder_enabled').val();
  if(is_preorder == 'true'){
  
  $("#metaShow").hide();
  function Timezone(date){
      let AusTime = date.toLocaleString("en-US", { 
                    timeZone: "Australia/Sydney"  
                });
  	return new Date(AusTime);
  }
  
  
  var date = new Date();
  date = Timezone(date);
  var y = date.getFullYear();
  var m = date.getMonth()+1;
  var d = date.getDate();
  if(m.toString().length == 1 ){
    var month = m.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
  }
  else{
    var month = m;
  }
  
  if(d.toString().length == 1 ){
    var today_date = d.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
  }
  else{
    var today_date = d;
  }
  var hours = date.getHours().toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    });
  
  var token = "token"+date.getFullYear()+''+month+''+today_date+''+hours;
  // console.log(token, month, m.toString().length, $(".product-form--atc button[type='submit']").text(), $("#product-add button[type='submit']").html());
  var prod_id = $('.product-page').attr('data-product-id');
  var prod_handle = $('.product-page').attr('data-product-handle');
  $(".product-form--atc button[type='submit']").attr('disabled', true);
  $(".product-form--atc button[type='submit']").text('Fetching details please wait...'); 
  if( !localStorage.getItem('firstLoad') )
  {
    $("body").on("click", ".swatch-element .ced-swatch", function() {
      setTimeout(function(){
        $(".product-form--atc button[type='submit']").attr('disabled', true);
        $(".product-form--atc button[type='submit']").text('Fetching details please wait...');
      },100);
    });
  }
  else{
    $("body").on("click", ".swatch-element", function() {
      setTimeout(function(){$(".product-form--atc button[type='submit']").attr('disabled', true);}, 100);        
    });
  }
  
  
  $.get("/apps/preorders?prod_id=" + prod_id + "&token="+token+"",function(data, status){
    data = JSON.parse(data);
    if(status == 'success' && typeof(data['product']) != undefined && data['product'] != null && data['product'] != ""){
        setTimeout(function(){  
          var get_url = window.location.href;
          var url = new URL(get_url);
          var c = url.searchParams.get("updated");
          if( !localStorage.getItem('firstLoad') )
          {
            localStorage['firstLoad'] = true;
            window.location.reload(true);
            
            // console.log(status, 'false');
          }  
          else{          
            renderUpdatedData();
//             $('#fetch-msg').hide();
//             $('#success-msg span').show();
            localStorage.removeItem('firstLoad');
          }
        }, 3500);
    }
    else
    {
      renderUpdatedData();
      $('.error-msg span').show();
      $(".product-form--atc button[type='submit']").attr('disabled','true');
      $(".product-form--atc button[type='submit']").text('Not available try again');
    }
    
  }); 
  }
  
  function renderUpdatedData(){
   
   var prod_json = $('.product-json').text();
   var data = JSON.parse(prod_json);
  //console.log( $('.product-json'));
  
//   ------------ Main ------------------    //
    var defaultId = $('#default_id').val();
    var variant = data['variants'];
    var url = new URL(window.location.href);
    url = url.searchParams.get("variant");
    
    $("body").on("click", "label.ced-swatch", function() {
      setTimeout(function() {
        let url = new URL(window.location.href);
    	url = url.searchParams.get("variant");
        // console.log(url);
        $.each(variant, function(key, val) {
          let value = val['id'];
          if (value == url) {
            let variantData = variant[key];
            var metaDate = $('.ced-variant-'+url+'').val();
            var variantStatus = variantData['inventory_policy'].trim();
            // console.log(variantStatus, metaDate);
            $(".product-form--atc button[type='submit']").removeAttr('disabled', true);
            if (variantStatus == 'continue' && metaDate != "-") {
              $(".product-form--atc button[type='submit']").text('Preorder Now');
              $("#dispatchDate").attr('name','properties[ETA Despatches Date]');
              $("#orderType").attr('name','properties[Order Type]').val('Preorder');
              $(".ced-badge span").text('Pre-Order ETA-'+metaDate);
              $("#metaShow").show();
              $("#dispatchDate").val(metaDate);
              $("#metaShow span").text(metaDate);
              $(".ced-badge").show();
            } else if(variantStatus == 'deny' && variantData['inventory_quantity'] >0) {
              $(".product-form--atc button[type='submit']").text('Add to cart');
              $("#dispatchDate, #orderType").removeAttr('name');
              $("#metaShow").hide();
              $(".ced-badge").hide();
              $(".ced-badge span").text('');
            }
            else if(variantStatus == 'deny' && variantData['inventory_quantity'] == 0){
              $("#dispatchDate, #orderType").removeAttr('name');
              $("#metaShow").hide();
              $(".ced-badge").hide();
              $(".ced-badge span").text('');
            }
            else if(variantStatus == 'deny'){
              $("#dispatchDate, #orderType").removeAttr('name').val('');
              //$("#dispatchDate").hide();
              $("#metaShow").hide();
              $(".ced-badge").hide();
            }
          }
        })
      }, 300);
    })
    //console.log(url, defaultId);    
    $.each(variant, function(key, val) {
      $(".product-form--atc button[type='submit']").removeAttr('disabled', true);
      let value = val['id'];
      if (value == defaultId && url ==  null) {
        // console.log(url, defaultId, "159");
        let variantData = variant[key];
        var metaDate = $('.ced-variant-'+defaultId+'').val();
        var variantStatus = variantData['inventory_policy'].trim();
        // console.log("render update if", metaDate, variantData, variantStatus)
        if (variantStatus == 'continue' && metaDate != "-") { 
          $("#dispatchDate").attr('name','properties[ETA Despatches Date]');
          $("#orderType").attr('name','properties[Order Type]').val('Preorder');
		  $("#metaShow").show();
          $("#metaShow span").text(metaDate);
          $(".ced-badge").show();
          $(".ced-badge span").text('Pre-Order ETA-'+metaDate);
          $(".product-form--atc button[type='submit']").text('Preorder Now');
          $("#orderType").val('Preorder');
          $("#dispatchDate").val(metaDate);
        } else if (variantStatus == 'deny' && variantData['inventory_quantity'] >0){
          $(".product-form--atc button[type='submit']").text('Add to cart');
          $("#orderType").val('Add to cart');
          $("#dispatchDate, #orderType").removeAttr('name');
          $("#metaShow").hide();
          $(".ced-badge span").text('');
          $(".ced-badge").hide();
        }
        else if(variantStatus == 'deny' && variantData['inventory_quantity'] == 0){
          $("#dispatchDate, #orderType").removeAttr('name');
          //$("#dispatchDate").hide();
          $(".product-form--atc input[type='submit']").text('Sold Out');
          $("#metaShow").hide();
          $(".ced-badge").hide();
        }
        else if(variantStatus == 'deny'){
          $("#dispatchDate, #orderType").removeAttr('name').val('');
          //$("#dispatchDate").hide();
          $("#metaShow").hide();
          $(".ced-badge").hide();
        }
      }
      if (url != null && value == parseInt(url)) 
      {
        if(value == parseInt(url)  || url.length > 0){
          let variantData = variant[key];
          var metaDate = $('.ced-variant-'+url+'').val();
          var variantStatus = variantData['inventory_policy'].trim();
          // console.log("2-"+url,variantData, metaDate, variantStatus);
          if (variantStatus == 'continue' && metaDate != "-") { 
            $(".product-form--atc button[type='submit']").text('Preorder Now');
            $("#dispatchDate").attr('name','properties[ETA Despatches Date]').val(metaDate);
            $("#orderType").attr('name','properties[Order Type]').val('Preorder');
            $("#metaShow").show();
            $("#metaShow span").text(metaDate);
            $(".ced-badge").show();
            $(".ced-badge span").text('Pre-Order ETA-'+metaDate);            
            $("#orderType").val('Preorder');
          } 
          else if (variantStatus == 'deny' && variantData['inventory_quantity'] >0){
            $(".product-form--atc button[type='submit']").text('Add to cart');
            $("#dispatchDate").removeAttr('name');
            $("#orderType").removeAttr('name');
            $("#metaShow").hide();
            $(".ced-badge span").text('');
            $(".ced-badge").hide();
          }
          else if(variantStatus == 'deny' && variantData['inventory_quantity'] == 0){
            $("#dispatchDate, #orderType").removeAttr('name');
            //$("#dispatchDate").hide();
            $(".product-form--atc button[type='submit']").text('Sold Out');
            $("#metaShow").hide();
            $(".ced-badge").hide();
          }
          else if(variantStatus == 'deny'){
            $("#dispatchDate, #orderType").removeAttr('name').val('');
            //$("#dispatchDate").hide();
            $("#metaShow").hide();
            $(".ced-badge").hide();
          }
      	}
      }
    })
	
//     var swatches = $(".swatch-element .ced-swatch");
//     $.each(swatches, function(i){
//     	let vals = $(this).attr("data-id");
//      	let varr = variant[i];
//       console.log('var-'+varr);
//       	let inventory = varr['inventory_policy'];
//       	let title = varr['title'];
//       	if(inventory == 'continue' && title == vals)
//         {
//         	$(this).parent().removeClass('soldout');
//             $(this).parent().parent().siblings("#product-add").children("#addToCartBtn").removeAttr("disabled");
//             $("#orderType").val("Preorder");
//           	$("#metaShow").show();
//         }
//       else{
//       		$(this).parent().addClass('soldout');
//         	let btnchange = $(this).parent().parent().siblings("#product-add").children("#addToCartBtn");
//         	btnchange.attr("disabled","disabled");
//         	$("#metaShow").hide();
//       }
//     });
    
    
    
    
  }
});